import { z } from "zod";

const costBreakdownSchema = z.object({
  supervisorQuantity: z.number().min(0),
  supervisorHours: z.number().min(0),
  supervisorRate: z.number().min(0),
  technicianQuantity: z.number().min(0),
  technicianHours: z.number().min(0),
  technicianRate: z.number().min(0),
  equipment: z.number().min(0),
  other: z.number().min(0),
  workersCompEnabled: z.boolean(),
});

export const quoteFormSchema = z.object({
  isQuoteLumpSum: z.boolean().optional(),
  costBreakdownEnabled: z.boolean().optional(),
  costBreakdown: costBreakdownSchema,
  quoteDetails: z.array(
    z.object({
      is_editable: z.boolean(),
      item_name: z.string().min(1, "Item is required"),
      custom_item_name: z.string().optional(),
      quantity: z.number().min(1, "Quantity must be at least 1"),
      unit: z.string().min(1, "Unit is required"),
      custom_unit: z.string().optional(),
      cost_per_unit: z.number().min(0, "Cost per unit must be at least 0"),
      price_per_unit: z.number().min(0, "Price per unit must be at least 0"),
    })
  ),
  contactInfo: z.object({
    name: z.string().min(1, "Quote Name is required"),
    email: z.string().email({ message: "Invalid email address" }),
    salesman: z.string().email({ message: "Invalid email address" }),
  }),
  scopeDescription: z.string(),
  totalRevenueOverride: z.number().min(0, "Override must be 0 or greater").nullable().optional(),
});

export type QuoteFormSchema = z.infer<typeof quoteFormSchema>;
